<template>
  <div class="page-container">
    <slot name="pageTop" />
    <div v-if="$slots.title || $slots.pageExtra || title" class="page-header">
      <slot name="title">{{ title }}</slot>
      <slot name="pageExtra" />
    </div>
    <div class="page-divider">
      <template v-if="isLogin || upRouteName.includes(route?.name)">
        <slot />
      </template>
      <template v-else>
        <EmptyViewLogin class="-translate-y-1/2 top-1/2">
          <template #content></template>
        </EmptyViewLogin>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PageKey } from '~/constants/page'

defineProps<{ title?: string }>()
const session = useSession()
const upRouteName = [PageKey.TEAM_SPACE, PageKey.BRAND_MANAGE] // 共享空间、品牌规范
const route: any = useRoute()

const isLogin = computed(() => session.value?.user_id)
</script>

<style lang="scss" scoped>
.page-container {
  @apply p-[30px_30px_0] bg-back-bg h-full flex flex-col rounded-[16px] flex-1 overflow-auto;
  .page-header {
    @apply flex-between text-[20px] font-bold pb-[20px] leading-[32px] text-font-1;

    :deep(.ant-input-affix-wrapper-lg) {
      @apply p-[0_10px] text-[20px];
    }
  }
  .page-divider {
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }
}
</style>

<style lang="scss">
.page-container {
  .ant-spin-nested-loading {
    height: calc(100% - 40px);
    min-height: 100px;
    .ant-spin-container {
      height: 100%;
      .list-card {
        height: 100%;
      }
    }
  }
}
</style>
